<template>
  <Select
    v-if="currentTheme"
    :options="themes"
    :value="currentTheme"
    position="bottom-end"
    :button-class="buttonClass"
    :chevron-size="0"
    :fullscreen="$windowSize.isMobile"
    @input="changeTheme"
  >
    <template #title>
      {{ $t('titles.themes.Select theme') }}
    </template>
    <template #current-option-icon="{ option }">
      <span
        v-if="!$windowSize.isMobile"
        v-hint="{
          position: 'left-center',
          yOffset: 8,
          text: $t('titles.themes.title'),
          showDelay: 600,
        }"
        class="align-center text-primary hover:text-primary-active relative flex flex h-6 w-6 cursor-pointer items-center justify-center rounded transition-colors after:absolute after:-left-0.5 after:-top-0.5 after:-z-10 after:h-7 after:w-7 after:rounded after:transition-colors hover:after:bg-gray-100 dark:hover:after:bg-neutral-800"
      >
        <lucide-icon :icon="option?.icon" size="18" />
      </span>
      <lucide-icon
        v-else
        class="text-primary me-2"
        :icon="option?.icon"
        size="16"
      />
    </template>
    <template v-if="$windowSize.isMobile" #current-option="{ option }">
      <div class="text-sm">
        {{ $t('titles.themes.title') }}
      </div>
    </template>
    <template #option="{ option }">
      {{ $t('titles.themes.' + option.id) }}
    </template>
    <template #option-icon="{ option }">
      <lucide-icon :icon="option.icon" size="16" class="mr-2 rtl:ml-2" />
    </template>
  </Select>
</template>
<script>
import Select from '@/components/ui/Select';

import Hint from '@/libs/directives/Hint';

export default {
  name: 'LanguageSelect',
  components: {
    Select,
  },
  directives: {
    Hint,
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentTheme: null,
      themes: [
        {
          id: 'light',
          icon: 'Sun',
        },
        {
          id: 'device',
          icon: 'Airplay',
        },
        {
          id: 'dark',
          icon: 'Moon',
        },
      ],
    };
  },
  computed: {},
  mounted() {
    let theme = 'light';
    try {
      theme = localStorage.getItem('theme');
    } catch (e) {}

    this.currentTheme =
      this.themes.find((t) => t.id === theme) || this.themes[0];
  },
  methods: {
    changeTheme(theme) {
      this.currentTheme = theme;

      this.$changeTheme(theme.id);
    },
  },
};
</script>
